import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "view_grid_active",
  "use": "view_grid_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"view_grid_active\"><g fill-rule=\"evenodd\" transform=\"translate(2 3)\"><rect width=\"7\" height=\"7\" rx=\"1\" /><rect width=\"7\" height=\"7\" x=\"8\" rx=\"1\" /><rect width=\"7\" height=\"7\" y=\"8\" rx=\"1\" /><rect width=\"7\" height=\"7\" x=\"8\" y=\"8\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol